<app-dialog-header [header]="'header.dateRange' | loc"></app-dialog-header>
<mat-dialog-content [formGroup]="form">
  <div class="row-reversed-3">
    <app-date-input
      [label]="'label.from' | loc"
      formControlName="from"
      [outsideLabel]="false"
      [max]="fromMaxDate"
    ></app-date-input>
    <button mat-stroked-button class="clear-button" (click)="clear('from')">{{ 'button.clear' | loc }}</button>
  </div>
  <div class="row-reversed-3">
    <app-date-input
      [label]="'label.to' | loc"
      formControlName="to"
      [outsideLabel]="false"
      [min]="form.value.from"
      [max]="today"
    ></app-date-input>
    <button mat-stroked-button class="clear-button" (click)="clear('to')">{{ 'button.clear' | loc }}</button>
  </div>
  <div class="centered">
    <button mat-stroked-button class="fliko-stroked-button" (click)="apply()">{{ 'button.getRaport' | loc }}</button>
  </div>
</mat-dialog-content>
